import styled from 'styled-components';
import { listViewSizing } from '@/app/components/searchPageStyled.ts';

export const RootListContainer = styled.div<{ hasSidebar?: boolean }>`
  display: flex;
  flex-direction: ${({ hasSidebar }) => (hasSidebar ? 'row' : 'column')};
  width: 100%;
  ${listViewSizing};
  min-width: 0;
`;

export const RootMapContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const HybridContainer = styled.div<{ isCurated?: boolean }>`
  display: flex;
  width: 100%;

  &.list-layout {
    ${listViewSizing};
  }
`;
